import BreakdownHOK from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/BreakdownHOK';

const FundDetailsBreakdownCreditProfileTable = () => {
  return <BreakdownHOK endpoint="credit" titleKey="fundDetailsBreakdownCreditTitle" />;
};

export default FundDetailsBreakdownCreditProfileTable;
